import { borrowerSideV2Fetch } from "./borrowerSideV2Client"

export const getCreditPullPaymentRequestV2 = (requestId) => (
    borrowerSideV2Fetch(`/borrowerside/v2/credit-pull/payment-requests/${encodeURIComponent(requestId)}`)
)

export class CreditPullPaymentError extends Error {
    constructor(message, payload = {}) {
        super(message || "Payment failed")
        this.name = "CreditPullPaymentError"
        this.payload = payload
    }
}

export const payCreditPullPaymentRequestV2 = async (requestId, body) => {
    const token = window.sessionStorage.getItem("ZeitroA")
    const response = await fetch(
        `${window.location.origin}/borrowerside/v2/credit-pull/payment-requests/${encodeURIComponent(requestId)}/pay`,
        {
            method: "POST",
            cache: "no-cache",
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(body),
        },
    )
    const payload = await response.json().catch(() => ({}))
    if (!response.ok || payload.Status === "Error") {
        throw new CreditPullPaymentError(
            payload.Message || payload.errMessage || "Payment failed. Please try again.",
            payload,
        )
    }
    return payload
}

export const listPendingCreditPullPaymentRequestsV2 = () => (
    borrowerSideV2Fetch("/borrowerside/v2/credit-pull/payment-requests")
)
